import { LivePaymentProvider } from './payment-provider';

/**
 * Typed as `LivePaymentProvider`, which excludes `'manual'` — so a production
 * build that charges nobody cannot be produced by editing this line.
 *
 * NOTE: the server has no Stripe adapter yet, so `payment_url` still comes
 * back null and the flow waits on the return route. That is a server gap, not
 * something this setting can paper over.
 */
const paymentProvider: LivePaymentProvider = 'stripe';

export const environment = {
  production: true,
  host: 'https://api.skiss.org',
  port: '443',
  apiBaseUrl: 'https://api.skiss.org',
  wsHost: 'wss://api.skiss.org',
  wsPort: '443',
  paymentProvider,
};
